// Keep content the same physical size in landscape as in portrait.
// Portrait: viewport=700 → browser scales 700 to fit narrow edge.
// Landscape: scale viewport width up so the scale factor stays the same.
// Also bump base font size slightly on small screens to aid readability.
(() => {
  const BASE = 700;
  const meta = document.getElementById("metaViewport");
  const mql = window.matchMedia("(orientation: landscape)");
  const narrow = Math.min(screen.width, screen.height);
  const wide = Math.max(screen.width, screen.height);

  function update() {
    const w = mql.matches ? Math.round(BASE * wide / narrow) : BASE;
    meta.content = `width=${w}, minimum-scale=0.5`;
  }

  // On scaled-down screens, nudge the base font size up
  if (narrow < BASE) {
    document.documentElement.style.setProperty("--bl-base-font-size", "1.2em");
  }

  mql.addEventListener("change", update);
  update();
})();
